import 'maz-ui/styles'
// import Vue from "vue";

// Styles
import "@/scss/index.scss";
import "@/assets/css/nucleo-icons.css";
import createVueApp from "./createApp";

createVueApp();
